module.exports = __webpack_public_path__ + "img/mittelstandDigitalLogo.09b62f07.png";